<template>
  <div class="number-input">
    <div class="input-content">
      <button @click="minus">
        －
      </button>
  
      <p>
        {{ inner }}
      </p>
  
      <button @click="plus">
        ＋
      </button>

    </div>
  </div>
</template>

<script>
export default {
  name: 'NumberInput',
  data() {
    return {
      inner: 1,
    };
  },
  props: {
    value: {
      type: Number,
      default: 1,
    },
  },
  created() {
    this.inner = this.value;
  },
  computed: {
    innerVal: {
      get() {
        return parseInt(this.value);
      },
      set(v) {
        this.$emit('input', parseInt(v));
      }
    },
  },
  watch: {
    value(v) {
      console.log('value changed');
      this.inner = parseInt(v);
    },
    inner(v) {
      console.log('inner changed');
      this.$emit('input', v);
    }
  },
  methods: {
    plus() {
      this.inner += 1;
    },
    minus() {
      if (this.inner > 1) {
        this.inner -= 1;
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.number-input {
  display: inline-block;

  .input-content {
    display: flex;
    color: #333333;
  }

  button {
    padding: 6px 8px;
    background-color: #fff;
    border: solid 1px #333333;
    &:first-child {
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
    &:last-child {
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }
  p {
    margin: 0;
    padding: 6px;
    text-align: center;
    min-width: 80px;
    border-top: solid 1px #333333;
    border-bottom: solid 1px #333333;
  }
}
</style>